import { Controller } from "@hotwired/stimulus";
import { post, destroy } from "@rails/request.js";

// A switch that creates or destroys a resource rather than PATCHing a column: checked
// POSTs, unchecked DELETEs, both to the same URL.
export default class extends Controller {
  static values = {
    url: String,
    // Opt in to "turbo-stream" where the response has to re-render state that depends on
    // the resource -- request.js renders the stream itself.
    responseKind: { type: String, default: "html" },
  };

  toggle() {
    const request = this.element.checked ? post : destroy;

    request(this.urlValue, { responseKind: this.responseKindValue });
  }
}
